<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">德育评价活跃率前TOP5</div>
				<!-- <div class="blockTitleR">66666</div> -->
			</div>
			<div class="blockContent dataV2">
				<div class="charts borderRight">
					<div class="gauge">
						<dv-charts :option="option" />
					</div>
					<div>
						<div class="title1">德育评价</div>
						<div class="title2">平均活跃率</div>
					</div>
				</div>
				<div class="scrollBlock">
					<my-scroll-border v-if="config.data.length>0" :config="config" :column="3" :row="1">
						<template v-slot="{item}">
							<div class="scrollItem">
								<div class="ranking">{{item.ranking}}</div>
								<div class="schInfo">
									<div class="flex_between">
										<div class="schName">{{item.name}}</div>
										<div class="progressNum">{{item.num}}</div>
									</div>
									<div class="progress">
										<div class="progressBar"></div>
									</div>
								</div>
							</div>
						</template>
					</my-scroll-border>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import myScrollBorder from './SVG/data-view/myScrollBorder.vue'
	export default {
		components: {
			myScrollBorder,
		},
		data() {
			return {
				option: {
					series: [{
						type: 'gauge',
						startAngle: -Math.PI / 2,
						endAngle: Math.PI * 1.5,
						arcLineWidth: 25,
						radius: '75%',
						data: [{
							name: 'itemA',
							value: 65,
							gradient: ['#03c2fd', '#1ed3e5', '#2fded6']
						}],
						axisLabel: {
							show: false
						},
						axisTick: {
							show: false
						},
						pointer: {
							show: false
						},
						dataItemStyle: {
							lineCap: ''
						},
						details: {
							show: true,
							formatter: '{value}%',
							style: {
								fill: '#1ed3e5',
								fontSize: 24
							}
						},
						backgroundArc: {
							style: {
								stroke: '#333333'
							}
						}
					}]
				},
				config: {
					data: [{
							ranking: 1,
							name: '龙霞实验小学1',
							num: 96.8
						},
						{
							ranking: 2,
							name: '龙霞实验小学2',
							num: 96.3
						},
						{
							ranking: 3,
							name: '龙霞实验小学3',
							num: 95.3
						},
						{
							ranking: 4,
							name: '龙霞实验小学4',
							num: 92
						},
						{
							ranking: 5,
							name: '龙霞实验小学5',
							num: 91
						},
						{
							ranking: 6,
							name: '龙霞实验小学6',
							num: 97
						},
					]
				},
			}
		}
	}
</script>

<style lang="less">
	.dataV2 {
		display: flex;

		.charts {
			width: 40%;
			height: 100%;
			display: flex;
			align-items: center;

			.gauge {
				width: 65%;
				height: 100%;
			}
			.title1 {
				font-size: 20px;
			}
			.title2 {
				font-size: 16px;
			}
		}

		.scrollBlock {
			width: 60%;
			.scrollItem {
				height: 68px;
				width: 100%;
				margin: 6px 0;
				display: flex;
				align-items: center;
				.ranking {
					margin: 0 12px;
					padding: 10px;
					font-size: 14px;
				}
				.schInfo {
					width: calc(100% - 80px);
					.schName {
						margin-bottom: 6px;
						font-size: 16px;
					}
					.progressNum {
						font-size: 18px;
					}
					.progress {
						width: 100%;
						display: flex;
						align-items: center;
						.progressBar {
							width: 100%;
							height: 6px;
							background-color: #00baff;
						}
					}
				}
			}
		}
	}
</style>
